import React from 'react';

import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

type OpenCloseArrowProps = {
  open: boolean;
};

const OpenCloseArrow = ({ open }: OpenCloseArrowProps) => {
  if (open) {
    return <KeyboardArrowUpRoundedIcon fontSize="medium" color="primary" />;
  } else {
    return <KeyboardArrowDownRoundedIcon fontSize="medium" />;
  }
};

export { OpenCloseArrow };
